import { useTranslation } from 'react-i18next';

import { useUpdateCommunityProfile } from '~/api/community/useUpdateCommunityProfile';
import { useUser } from '~/api/user';
import { Button, Icon } from '~/components';
import { toast } from '~/utils/toast';

import { CommunityProfileCardSkeleton } from './components/CommunityProfileCard.skeleton';
import { contentStyle, gridStyle, overlayStyle, wrapperStyle } from './NetworkLocked.css';

export const NetworkLocked = () => {
  const { t } = useTranslation(['common', 'community']);

  const { data: user } = useUser();
  const communityProfile = user.communityProfile;

  const updateCommunityProfile = useUpdateCommunityProfile(communityProfile.id);

  const makeProfilePublic = () => {
    updateCommunityProfile.mutate(
      {
        brandId: communityProfile.brandId,
        description: communityProfile.description,
        email: communityProfile.email,
        enabled: true,
        links: communityProfile.links,
        openToWork: communityProfile.openToWork,
        regions: communityProfile.regions,
      },
      {
        onError: () => toast.danger({ description: t('common:error') }),
        onSuccess: () => toast.success({ description: t('community:overview.locked.success') }),
      },
    );
  };

  return (
    <div className={wrapperStyle}>
      <div className={overlayStyle}>
        <div className={contentStyle}>
          <Icon name="Lock" size={50} />

          <p>{t('community:overview.locked.description')}</p>

          <Button loading={updateCommunityProfile.isPending} onClick={makeProfilePublic}>
            {t('community:overview.locked.button')}
          </Button>
        </div>
      </div>

      <div aria-hidden className={gridStyle}>
        {Array.from({ length: 6 }, () => null).map((_, i) => (
          <CommunityProfileCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
};
